"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizeIcon24 = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var build_svg_icon_1 = require("../../build-svg-icon");
exports.CustomizeIcon24 = (0, build_svg_icon_1.buildSvgIcon)(function () {
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('customize-icon24')), 1), uniqueId = _a[0];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(uniqueId, ")") },
            react_1.default.createElement("path", { d: "M8.90125 5.59507C9.07221 5.22776 9.59445 5.22776 9.76542 5.59507L11.6667 9.6799C12.1215 10.6571 12.8942 11.4513 13.8586 11.9328L17.8126 13.907C18.1642 14.0826 18.1642 14.5843 17.8126 14.7598L13.8586 16.734C12.8942 17.2155 12.1215 18.0097 11.6667 18.9869L9.76542 23.0718C9.59445 23.4391 9.07221 23.4391 8.90125 23.0718L6.99996 18.9869C6.54512 18.0097 5.77246 17.2155 4.8081 16.734L0.854017 14.7598C0.50242 14.5843 0.502419 14.0826 0.854017 13.907L4.80809 11.9328C5.77246 11.4513 6.54512 10.6571 6.99996 9.6799L8.90125 5.59507Z", fill: "currentColor" }),
            react_1.default.createElement("path", { d: "M19.1055 0.505991C19.1938 0.309708 19.4725 0.309708 19.5608 0.505991L20.4938 2.57954C20.7252 3.09376 21.1238 3.5145 21.6248 3.77327L23.5704 4.77819C23.7505 4.87122 23.7505 5.12878 23.5704 5.22181L21.6248 6.22673C21.1238 6.4855 20.7252 6.90624 20.4938 7.42046L19.5608 9.49401C19.4725 9.69029 19.1938 9.69029 19.1055 9.49401L18.1725 7.42046C17.9412 6.90624 17.5426 6.4855 17.0416 6.22673L15.0959 5.22181C14.9158 5.12878 14.9158 4.87122 15.0959 4.77819L17.0416 3.77327C17.5426 3.5145 17.9412 3.09376 18.1725 2.57954L19.1055 0.505991Z", fill: "currentColor" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: uniqueId },
                react_1.default.createElement("rect", { width: "24", height: "24", fill: "currentColor" })))));
}, 'CustomizeIcon24', { viewBox: '0 0 24 24' });
exports.default = exports.CustomizeIcon24;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9taXplSWNvbjI0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vZGVzaWduLXN5c3RlbS1pY29ucy91aS1pY29ucy8yNC9DdXN0b21pemVJY29uMjQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUF3QztBQUN4Qyw2REFBd0M7QUFDeEMsdURBQW9EO0FBRXZDLFFBQUEsZUFBZSxHQUFHLElBQUEsNkJBQVksRUFDekM7SUFDUSxJQUFBLEtBQUEsT0FBYSxJQUFBLGdCQUFRLEVBQUMsSUFBQSxrQkFBUyxFQUFDLGtCQUFrQixDQUFDLENBQUMsSUFBQSxFQUFuRCxRQUFRLFFBQTJDLENBQUM7SUFDM0QsT0FBTyxDQUNMO1FBQ0UscUNBQUcsUUFBUSxFQUFFLGVBQVEsUUFBUSxNQUFHO1lBQzlCLHdDQUNFLENBQUMsRUFBQywrZ0JBQStnQixFQUNqaEIsSUFBSSxFQUFDLGNBQWMsR0FDbkI7WUFDRix3Q0FDRSxDQUFDLEVBQUMsb2hCQUFvaEIsRUFDdGhCLElBQUksRUFBQyxjQUFjLEdBQ25CLENBQ0E7UUFDSjtZQUNFLDRDQUFVLEVBQUUsRUFBRSxRQUFRO2dCQUNwQix3Q0FBTSxLQUFLLEVBQUMsSUFBSSxFQUFDLE1BQU0sRUFBQyxJQUFJLEVBQUMsSUFBSSxFQUFDLGNBQWMsR0FBRyxDQUMxQyxDQUNOLENBQ04sQ0FDSixDQUFDO0FBQ0osQ0FBQyxFQUNELGlCQUFpQixFQUNqQixFQUFFLE9BQU8sRUFBRSxXQUFXLEVBQUUsQ0FDekIsQ0FBQztBQUVGLGtCQUFlLHVCQUFlLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/ui-icons/24/CustomizeIcon24.js
// module id = 5200
// module chunks = 25